import { Routes } from "@angular/router";
import { ROUTES } from "./shared/constant/routes.const";
import { PKeyGuard as PGuard } from "./core/guards/p-key.guard";
import { AccessTknGuard as TGuard } from "./core/guards/access-tkn.guard";
import { ClientIdGuard as CGuard } from "./core/guards/client-id.guard";

export const APP_ROUTES: Routes = [
  {
    path: ROUTES.VALIDATE_CODE,
    loadComponent: () =>
      import("./pages/send-otp/send-otp.component").then(
        (m) => m.SendOtpComponent
      ),
    canActivate: [PGuard],
  },
  {
    path: ROUTES.BIOMETRY,
    loadComponent: () =>
      import("./pages/verify-identity/verify-identity.component").then(
        (m) => m.VerifyIdentityComponent
      ),
    canActivate: [PGuard, TGuard, CGuard],
  },
  {
    path: ROUTES.VIEW_CODE,
    loadComponent: () =>
      import("./pages/see-code/see-code.component").then(
        (m) => m.SeeCodeComponent
      ),
    canActivate: [PGuard, TGuard, CGuard],
  },
  {
    path: ROUTES.BLOCK_PROCESS,
    loadComponent: () =>
      import("./pages/block-process/block-process.component").then(
        (m) => m.BlockProcessComponent
      )
  },
  {
    path: "**",
    pathMatch: "full",
    redirectTo: ROUTES.VALIDATE_CODE,
  },
];
